<template>
    <section class="component" style="position: relative; flex-grow: 1;">
        <section class="component__header">
            <span class="component__header__title">
                {{ $t('com.file.client-invoice-data-settings.title') }}
            </span>
            <section class="component__header__action">
                <button class="component__button component__button--small component__button--white"
                    @click="openBuyerModal" :disabled="isLoading">
                    <span class="component__button__text">{{ $t('com.global.edit') }}</span>
                </button>
            </section>
        </section>
        <section class="component__body client-invoice-data">
            <section class="client-invoice-data__row">
                <label class="client-invoice-data__label">{{ $t('com.file.client-invoice-data-settings.invoice-email')
                    }}</label>
                <span class="client-invoice-data__value">{{ formatValue(form.invoiceEmail) }}</span>
            </section>

            <section class="client-invoice-data__columns d-flex flex-row">
                <section class="client-invoice-data__group">
                    <h5 class="client-invoice-data__group__title">{{ $t('com.file.client-invoice-data-settings.buyer')
                        }}
                    </h5>
                    <section class="client-invoice-data__row">
                        <label class="client-invoice-data__label">{{ $t('com.file.client-invoice-data-settings.buyer-group') }}</label>
                        <span class="client-invoice-data__value">{{ formatGroup(form.buyerGroup) }}</span>
                    </section>
                    <section class="client-invoice-data__row">
                        <label class="client-invoice-data__label">{{ $t('com.file.client-invoice-data-settings.name') }}</label>
                        <span class="client-invoice-data__value">{{ formatValue(form.buyer.name) }}</span>
                    </section>
                    <section class="client-invoice-data__row">
                        <label class="client-invoice-data__label">{{ $t('com.file.client-invoice-data-settings.address') }}</label>
                        <span class="client-invoice-data__value">{{ formatValue(form.buyer.address) }}</span>
                    </section>
                    <section class="client-invoice-data__row">
                        <label class="client-invoice-data__label">{{
                    $t('com.file.client-invoice-data-settings.postal-code') }}</label>
                        <span class="client-invoice-data__value">{{ formatValue(form.buyer.postalCode) }}</span>
                    </section>
                    <section class="client-invoice-data__row">
                        <label class="client-invoice-data__label">{{ $t('com.file.client-invoice-data-settings.city')
                            }}</label>
                        <span class="client-invoice-data__value">{{ formatValue(form.buyer.city) }}</span>
                    </section>
                    <section class="client-invoice-data__row">
                        <label class="client-invoice-data__label">{{
                    $t('com.file.client-invoice-data-settings.post-office') }}</label>
                        <span class="client-invoice-data__value">{{ formatValue(form.buyer.postOffice) }}</span>
                    </section>
                    <section class="client-invoice-data__row">
                        <label class="client-invoice-data__label">{{ $t('com.file.client-invoice-data-settings.gln')
                            }}</label>
                        <span class="client-invoice-data__value">{{ formatValue(form.buyer.gln) }}</span>
                    </section>
                    <section class="client-invoice-data__row">
                        <label class="client-invoice-data__label">{{ $t('com.file.client-invoice-data-settings.tax-id')
                            }}</label>
                        <span class="client-invoice-data__value">{{ formatValue(form.buyer.taxId) }}</span>
                    </section>
                    <section class="client-invoice-data__row">
                        <label class="client-invoice-data__label">{{
                    $t('com.file.client-invoice-data-settings.country-id') }}</label>
                        <span class="client-invoice-data__value">{{ formatCountry(form.buyer.country) }}</span>
                    </section>
                </section>

                <section class="client-invoice-data__group">
                    <h5 class="client-invoice-data__group__title">
                     1. {{ $t('com.file.client-invoice-data-settings.recipient') }}</h5>
                    <section class="client-invoice-data__row">
                        <label class="client-invoice-data__label">{{
                    $t('com.file.client-invoice-data-settings.recipient-role') }}</label>
                        <span class="client-invoice-data__value">{{ formatRole(form.recipientRole) }}</span>
                    </section>
                    <section class="client-invoice-data__row">
                        <label class="client-invoice-data__label">{{ $t('com.file.client-invoice-data-settings.name')
                            }}</label>
                        <span class="client-invoice-data__value">{{ formatValue(form.recipient.name) }}</span>
                    </section>
                    <section class="client-invoice-data__row">
                        <label class="client-invoice-data__label">{{ $t('com.file.client-invoice-data-settings.address')
                            }}</label>
                        <span class="client-invoice-data__value">{{ formatValue(form.recipient.address) }}</span>
                    </section>
                    <section class="client-invoice-data__row">
                        <label class="client-invoice-data__label">{{
                    $t('com.file.client-invoice-data-settings.postal-code') }}</label>
                        <span class="client-invoice-data__value">{{ formatValue(form.recipient.postalCode) }}</span>
                    </section>
                    <section class="client-invoice-data__row">
                        <label class="client-invoice-data__label">{{ $t('com.file.client-invoice-data-settings.city')
                            }}</label>
                        <span class="client-invoice-data__value">{{ formatValue(form.recipient.city) }}</span>
                    </section>
                    <section class="client-invoice-data__row">
                        <label class="client-invoice-data__label">{{
                    $t('com.file.client-invoice-data-settings.post-office') }}</label>
                        <span class="client-invoice-data__value">{{ formatValue(form.recipient.postOffice) }}</span>
                    </section>
                    <section class="client-invoice-data__row">
                        <label class="client-invoice-data__label">{{ $t('com.file.client-invoice-data-settings.gln')
                            }}</label>
                        <span class="client-invoice-data__value">{{ formatValue(form.recipient.gln) }}</span>
                    </section>
                    <section class="client-invoice-data__row">
                        <label class="client-invoice-data__label">{{ $t('com.file.client-invoice-data-settings.tax-id')
                            }}</label>
                        <span class="client-invoice-data__value">{{ formatValue(form.recipient.taxId) }}</span>
                    </section>
                    <section class="client-invoice-data__row">
                        <label class="client-invoice-data__label">{{
                            $t('com.file.client-invoice-data-settings.recipient-internal-identifier') }}</label>
                        <span class="client-invoice-data__value">{{ formatValue(form.recipientInternalIdentifier)
                            }}</span>
                    </section>
                    <section class="client-invoice-data__row">
                        <label class="client-invoice-data__label">{{
                            $t('com.file.client-invoice-data-settings.country-id') }}</label>
                        <span class="client-invoice-data__value">{{ formatCountry(form.recipient.country) }}</span>
                    </section>
                </section>

                <section v-for="(recipient, idx) in (form.additionalRecipiants || [])" :key="'add-' + idx"
                    class="client-invoice-data__group">
                    <h5 class="client-invoice-data__group__title">
                        {{ idx + 2 }}. {{ $t('com.file.client-invoice-data-settings.recipient') }}
                    </h5>
                    <section class="client-invoice-data__row">
                        <label class="client-invoice-data__label">{{ $t('com.file.client-invoice-data-settings.recipient-role') }}</label>
                        <span class="client-invoice-data__value">{{ formatRole(recipient.recipientRole) }}</span>
                    </section>
                    <section class="client-invoice-data__row">
                        <label class="client-invoice-data__label">{{ $t('com.file.client-invoice-data-settings.name') }}</label>
                        <span class="client-invoice-data__value">{{ formatValue(recipient.name) }}</span>
                    </section>
                    <section class="client-invoice-data__row">
                        <label class="client-invoice-data__label">{{ $t('com.file.client-invoice-data-settings.address') }}</label>
                        <span class="client-invoice-data__value">{{ formatValue(recipient.address) }}</span>
                    </section>
                    <section class="client-invoice-data__row">
                        <label class="client-invoice-data__label">{{ $t('com.file.client-invoice-data-settings.postal-code') }}</label>
                        <span class="client-invoice-data__value">{{ formatValue(recipient.postalCode) }}</span>
                    </section>
                    <section class="client-invoice-data__row">
                        <label class="client-invoice-data__label">{{ $t('com.file.client-invoice-data-settings.city') }}</label>
                        <span class="client-invoice-data__value">{{ formatValue(recipient.city) }}</span>
                    </section>
                    <section class="client-invoice-data__row">
                        <label class="client-invoice-data__label">{{ $t('com.file.client-invoice-data-settings.post-office') }}</label>
                        <span class="client-invoice-data__value">{{ formatValue(recipient.postOffice) }}</span>
                    </section>
                    <section class="client-invoice-data__row">
                        <label class="client-invoice-data__label">{{ $t('com.file.client-invoice-data-settings.gln') }}</label>
                        <span class="client-invoice-data__value">{{ formatValue(recipient.gln) }}</span>
                    </section>
                    <section class="client-invoice-data__row">
                        <label class="client-invoice-data__label">{{ $t('com.file.client-invoice-data-settings.tax-id') }}</label>
                        <span class="client-invoice-data__value">{{ formatValue(recipient.taxId) }}</span>
                    </section>
                    <section class="client-invoice-data__row">
                        <label class="client-invoice-data__label">{{ $t('com.file.client-invoice-data-settings.recipient-internal-identifier') }}</label>
                        <span class="client-invoice-data__value">{{ formatValue(recipient.recipientInternalIdentifier) }}</span>
                    </section>
                    <section class="client-invoice-data__row">
                        <label class="client-invoice-data__label">{{ $t('com.file.client-invoice-data-settings.country-id') }}</label>
                        <span class="client-invoice-data__value">{{ formatCountry(recipient.country) }}</span>
                    </section>
                </section>
            </section>
            <section class="client-invoice-data__row">
                <label class="client-invoice-data__label">{{
                    $t('com.file.client-invoice-data-settings.last-verification-date') }}</label>
                <span class="client-invoice-data__value">{{ formatDate(form.lastVerificationDate) }}</span>
            </section>
        </section>
        <SmallLoader v-if="isLoading || isSaving" />
    </section>
</template>
<script charset="utf-8">
import SmallLoader from "@/components/BasicControls/SmallLoader.vue";
import ClientInvoiceDataService from "@/services/client.invoice.data.service";

const createEmptyContractor = () => ({
    name: "",
    address: "",
    postalCode: "",
    city: "",
    postOffice: "",
    taxId: "",
    gln: "",
    country: {
        id: 0,
        country: "",
        symbol: ""
    }
});

const createEmptyData = () => ({
    id: 0,
    buyer: createEmptyContractor(),
    recipient: createEmptyContractor(),
    additionalRecipiants: [],
    buyerGroup: null,
    recipientRole: null,
    recipientInternalIdentifier: "",
    invoiceEmail: "",
    lastVerificationDate: null
});

export default {
    name: "ClientInvoiceDataSettings",
    components: {
        SmallLoader
    },
    data() {
        return {
            form: createEmptyData(),
            isLoading: false,
            isSaving: false
        };
    },
    async mounted() {
        await this.loadData();
    },
    computed: {
        isBuyerModalOpen() {
            return this.$store.state.modals.settings.clientInvoiceBuyerModalStatus;
        }
    },
    watch: {
        isBuyerModalOpen(val, oldVal) {
            if (oldVal === true && val === false) {
                this.loadData();
            }
        }
    },
    methods: {
        cloneData(data) {
            return JSON.parse(JSON.stringify(data || createEmptyData()));
        },
        async loadData() {
            try {
                this.isLoading = true;
                this.$store.commit('setClientInvoiceDataLoading', true);
                await ClientInvoiceDataService.getClientInvoiceData();
                this.form = this.cloneData(this.$store.state.clientInvoiceDataStore.data);
            }
            catch (e) {
                this.$store.commit('setClientInvoiceDataError', e);
                console.log(e);
            }
            finally {
                this.isLoading = false;
                this.$store.commit('setClientInvoiceDataLoading', false);
            }
        },
        formatDate(value) {
            if (!value) {
                return "-";
            }

            const date = new Date(value);
            if (Number.isNaN(date.getTime())) {
                return value;
            }

            return date.toLocaleString();
        },
        formatValue(value) {
            if (value === null || value === undefined || value === "") {
                return "-";
            }

            return value;
        },
        formatCountry(country) {
            if (!country) {
                return "-";
            }

            const name = country.country || "";
            const symbol = country.symbol || "";

            if (name && symbol) {
                return `${name} (${symbol})`;
            }

            return name || symbol || "-";
        },
        formatGroup(group) {
            if (!group) {
                return "-";
            }

            const label = group.label || "";
            const code = group.code || "";

            if (label && code) {
                return `${label} (${code})`;
            }

            return label || code || "-";
        },
        formatRole(role) {
            if (!role) {
                return "-";
            }

            const label = role.label || "";
            const code = role.code || "";

            if (label && code) {
                return `${label} (${code})`;
            }

            return label || code || "-";
        },
        openBuyerModal() {
            this.$store.commit("setClientInvoiceBuyerModalStatus", true);
        }
    }
}
</script>
<style lang="scss">
@use "@/assets/scss/user-profile-component.scss";

.client-invoice-data {
    display: flex;
    flex-direction: column;
    row-gap: 12px;
    padding: 15px 10px;
    margin-left: 20px;
}

.client-invoice-data__columns {
    gap: 20px;
    flex-wrap: nowrap;
    overflow-x: auto;
}

.client-invoice-data__group {
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    border-top: 1px solid #e8ebef;
    padding-top: 10px;
    flex: 0 0 280px;
    min-width: 280px;
}

.client-invoice-data__group__title {
    font-size: 14px;
    font-weight: 700;
    margin: 0;
}

.client-invoice-data__row {
    display: flex;
    flex-direction: column;
    row-gap: 6px;
}

.client-invoice-data__label {
    font-size: 12px;
    font-weight: 600;
    color: #808396;
}

.client-invoice-data__value {
    font-size: 13px;
    color: #00082c;
}

.client-invoice-data__actions {
    display: none;
}
</style>
